import { pipe } from 'fp-ts/lib/function';
import * as O from 'fp-ts/Option';

import { NextStep, zeroStepProgress, type StepProgress } from '../model/domain/NextStep';
import { StudyStat } from '../model/domain/StudyStat';

const numberOfMainCardsToReview = (step: O.Option<NextStep>): number =>
  pipe(
    step,
    O.map((s) => s.progress.Main.total - s.progress.Main.done),
    O.getOrElse(() => 0)
  );

const numberOfCardsByStepMode = (step: O.Option<NextStep>): number =>
  pipe(
    step,
    O.map(
      (s) =>
        s.progress[s.mode as keyof typeof s.progress].total -
        s.progress[s.mode as keyof typeof s.progress].done
    ),
    O.getOrElse(() => 0)
  );

const getProgressOrZero = (step: O.Option<NextStep>): StepProgress =>
  pipe(
    step,
    O.map((step) => step.progress[step.mode as keyof typeof step.progress]),
    O.getOrElse(() => zeroStepProgress)
  );

const hasAssignedCards = (stat: O.Option<StudyStat>): boolean =>
  pipe(
    stat,
    O.map((s: StudyStat) => s.hasAssignedCards),
    O.getOrElse<boolean>(() => false)
  );

const getReviewCardNumber = (step: O.Option<NextStep>): number =>
  pipe(
    step,
    O.map((s) => s.progress.Review.total - s.progress.Review.done),
    O.getOrElse(() => 0)
  );

export default {
  numberOfMainCardsToReview,
  numberOfCardsByStepMode,
  getProgressOrZero,
  hasAssignedCards,
  getReviewCardNumber,
};
